<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import IMask from 'imask'; // https://imask.js.org/guide.html

import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldTime',
  components: {
    BaseField,
  },
  staticData: () => ({
    mask: {
      overwrite: true,
      autofix: true,
      mask: 'HH:MM',
      blocks: {
        HH: {
          mask: IMask.MaskedRange,
          placeholderChar: 'HH',
          from: 0,
          to: 23,
          maxLength: 2,
        },
        MM: {
          mask: IMask.MaskedRange,
          placeholderChar: 'MM',
          from: 0,
          to: 59,
          maxLength: 2,
        },
      },
      prepare: (appended, masked) => {
        const isDigit = /^\d+$/.test(appended);
        if (isDigit && appended > '2' && masked.value === '') {
          return `0${appended}`;
        }
        return appended;
      },
    },
  }),
  computed: {
    placeholder() {
      if (!this.$attrs.value) return this.$t('fields.time');
      const postfix = '__:__'.substring(this.$attrs.value.length);
      return this.$attrs.value + postfix;
    },
    attributes() {
      return {
        type: 'tel',
        label: this.$t('fields.timeLabel'),
        inputPlaceholder: this.placeholder,
        maskOptions: this.mask,
        checkIsComplete: (value) => /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/.test(value),
        required: true,
        ...this.$attrs,
      };
    },
  },
  methods: {
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    focus() {
      return this.$refs.field?.focus();
    },
  },
};
</script>
